import { render, staticRenderFns } from "./terminosCondiciones.vue?vue&type=template&id=6c533a1d"
import script from "./terminosCondiciones.vue?vue&type=script&lang=js"
export * from "./terminosCondiciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports